import { motion } from 'framer-motion';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import PortfolioHeader from '../components/portfolio/PortfolioHeader';
import MetricsBanner from '../components/portfolio/MetricsBanner';
import PortfolioComposition from '../components/portfolio/PortfolioComposition';
import PropertyList from '../components/portfolio/PropertyList';
import InvestorResources from '../components/portfolio/InvestorResources';

export default function Portfolio() {
  const [search] = useState('');

  return (
    <>
      <Helmet>
        <title>RentFi | Real Estate Investment Portfolio</title>
        <meta 
          name="description" 
          content="Explore RentFi's curated portfolio of high-yield real estate properties. View our current properties generating up to 12.88% annual yields, performance metrics, and global investment opportunities." 
        />
        <meta 
          name="keywords" 
          content="RentFi portfolio, real estate properties, property investment, rental yield, global real estate, property management, blockchain real estate" 
        />
        <link rel="canonical" href="https://rentfi.io/portfolio" />
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <PortfolioHeader />
            <MetricsBanner />
            <PortfolioComposition />

            {/* Global Portfolio Distribution Section */}
            <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
              <h2 className="text-primary text-center mb-4">Global Portfolio Distribution</h2>
              <p className="text-body-large text-gray-600 text-center mb-8">
                Experience true geographic diversification across prime locations worldwide
              </p>
              <div className="relative">
                <img 
                  src="https://rentfi.b-cdn.net/rentfi-map.webp"
                  alt="RentFi's Global Real Estate Portfolio Distribution Map - Properties Across Multiple Continents"
                  className="w-full h-auto rounded-lg"
                  width="1200"
                  height="600"
                />
              </div>
            </div>

            <PropertyList search={search} />
            <InvestorResources />
          </motion.div>
        </div>
      </div>
    </>
  );
}